import { render, staticRenderFns } from "./ImportServiceBundle.vue?vue&type=template&id=1176e634&"
import script from "./ImportServiceBundle.vue?vue&type=script&lang=js&"
export * from "./ImportServiceBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportServiceBundle.vue"
export default component.exports